import styled from 'styled-components'
import Popup from 'reactjs-popup';

export const BodyCard = styled.div`
text-align: left;
padding-right: 15px;
margin-top: 5px;
margin-bottom: 1.5em;
`

export const HeadCard = styled.div`
display: flex;
justify-content: space-between;
margin-top: .5em;
margin-bottom: 1.5em;
svg:hover {
    fill: ${(props) => props.color};
    cursor: pointer;
}
`

export const BottomCard = styled.div`
display: flex;
justify-content: flex-start;
margin-top: 1em;
margin-right: 10px;
`
export const TitleLocalization = styled.div`
    padding-left: 10px;
`
export const MobileLocalization = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
`

export const StyledPopup = styled(Popup)`
  &-content {
    z-index: 10000 !important;
    left: 50% !important;
    & div {
        border-radius: 0px !important;
    }
    @media (max-width: 600px) {
        left: 1% !important;
  }
`;